import "core-js/stable";
import "isomorphic-fetch";

import Vue from "vue";
import App from "./App";
import "./plugins/vuetify";
import i18n from "./plugins/i18n";
import router from "./router";
import "./survey";
import "./assets/fonts.css";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
